import type {
  GridLayouts,
  SinkConfig,
  SinkId,
  SourceConfig,
  SourceId,
  SourceSharedState
} from '../../../../Flux/Slice/Visualization/VisualizationSliceTypes.js'
import type { VisualizationState } from '../../../../Flux/Slice/Visualization/VisualizationSlice.js'

/**
 * Type of shared vis workspaces, basically an extract of the visualization slices' state
 */
export interface SavedViz {
  version: 'viz-v1'
  sources: Record<
    SourceId,
    {
      name: string
      config: SourceConfig
      shared: SourceSharedState
      sinks: Record<SinkId, { config: SinkConfig }>
      selectedBucketKeys?: string[]
    }
  >
  grid?: { layouts: GridLayouts }
}

export const selectSavableVizState = (state: VisualizationState): SavedViz => {
  return {
    version: state.version,
    sources: Object.fromEntries(
      Object.entries(state.sources).map(([id, src]) => [
        id,
        {
          name: src.name,
          config: src.config,
          shared: src.shared,
          sinks: src.sinks,
          selectedBucketKeys: src.state.selectedBucketKeys
        }
      ])
    ),
    grid: { layouts: state.grid.layouts }
  }
}

export type LoadSavedVizAction = {
  type: 'LoadSavedVizAction'
  saved: SavedViz
  asTemplate?: boolean
}

export function isLoadSavedVizAction(action: unknown): action is LoadSavedVizAction {
  return action !== null && typeof action === 'object' && 'type' in action && action.type === 'LoadSavedVizAction'
}
